import ReactSelect from 'react-select';
import { useField, ErrorMessage } from 'formik';
import classNames from 'classnames';

const Select = ({ label, isMulti, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const { value } = meta;
    const { setValue } = helpers;

    const getValue = (value) => {
        return props.options.find((option) => option.value === value);
    };

    return (
        <div className="form__group">
            <label className="form__label">
                {label}
                <div className="form__validation">
                    <ReactSelect
                        className={classNames('select', {
                            'select--error': meta.touched && meta.error,
                        })}
                        classNamePrefix="select"
                        {...field}
                        {...props}
                        value={getValue(value)}
                        onChange={(e) => {
                            if (isMulti) {
                                setValue(e.map((item) => item.value));
                            } else {
                                setValue(e.value);
                            }
                        }}
                        id="long-value-select"
                        isMulti={isMulti}
                        instanceId="long-value-select"
                    />
                    <ErrorMessage
                        name={field.name}
                        render={(msg) => (
                            <div className="form__helper">{msg}</div>
                        )}
                    />
                </div>
            </label>
        </div>
    );
};

export default Select;
